const errorMap = {
  INVALID_ELEMENTORSELECTOR: new Error('invalid_elementorselector'),
  FAILED_TO_OPEN_WINDOW: new Error('failed_to_open_window'),
};

export default errorMap;



// WEBPACK FOOTER //
// ./utils/errorUtils.js